import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

type DemoModeContextValue = {
  isDemoMode: boolean;
  /** @returns neuer Zustand (true = Demo an) */
  toggleDemoMode: () => boolean;
};

const DemoModeContext = createContext<DemoModeContextValue | null>(null);

const DEMO_MODE_STORAGE_KEY = "coupleup-demo-mode";

export function DemoModeProvider({ children }: { children: React.ReactNode }) {
  const [isDemoMode, setIsDemoMode] = useState<boolean>(() => {
    const saved = localStorage.getItem(DEMO_MODE_STORAGE_KEY);
    return saved === "true";
  });
  const isDemoModeRef = useRef(isDemoMode);
  useEffect(() => {
    isDemoModeRef.current = isDemoMode;
  }, [isDemoMode]);

  const toggleDemoMode = useCallback((): boolean => {
    const next = !isDemoModeRef.current;
    isDemoModeRef.current = next;
    if (next) {
      localStorage.setItem(DEMO_MODE_STORAGE_KEY, "true");
    } else {
      localStorage.removeItem(DEMO_MODE_STORAGE_KEY);
    }
    setIsDemoMode(next);
    return next;
  }, []);

  return (
    <DemoModeContext.Provider value={{ isDemoMode, toggleDemoMode }}>
      {children}
    </DemoModeContext.Provider>
  );
}

export function useDemoMode() {
  const context = useContext(DemoModeContext);
  if (!context) {
    throw new Error("useDemoMode must be used within DemoModeProvider");
  }
  return context;
}
